// Copyright: IQGeo Limited 2010-2019
import myw from 'myWorld/base/core';
import L from 'leaflet';

/**
 * Utility tile layer that identifies the bounds, x, y (and zoom) for each tile
 * @name TileIdentificationLayer
 * @constructor
 */
myw.TileIdentificationLayer = L.GridLayer.extend({
    options: {
        minZoom: 0,
        maxZoom: 21
    },

    createTile(coords) {
        const tile = L.DomUtil.create('div', 'tile-coords');
        tile.innerHTML = `<div class="tile-coords-info">Tile: ${coords.x},${coords.y}<br/>Zoom:${
            coords.z
        }</div>`;

        return tile;
    }
});

export default myw.TileIdentificationLayer;
